export default __webpack_public_path__ + "static/slide1-3461fad904be80dbfdd5088c58a4f67e.webp";